import React from 'react';

import BlockSidebarForm from '@dashboard/components/editor/EditorSidebar/BlockSidebarForm';
import { Box, Typography } from '@mui/material';
import { useCurrentBlockId } from '@wp-block-builder/editor/hooks';

export default function InspectSidebar() {
  const currentBlockId = useCurrentBlockId();

  if (!currentBlockId) {
    return (
      <Box sx={{ m: 3, p: 1, border: '1px dashed', borderColor: 'divider' }}>
        <Typography color="text.secondary">No block selected. Click on a block to inspect.</Typography>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <BlockSidebarForm blockId={currentBlockId} />
    </Box>
  );
}
